// Grupos do menu ("caixas") — cada conjunto de telas fica junto no seu grupo.
// A ordem aqui é a ordem que aparece no menu.
const GRUPOS = [
  { chave: "inicio", rotulo: null }, // sem cabeçalho (é o topo)
  { chave: "carteira", rotulo: "Carteira" },
  { chave: "financeiro", rotulo: "Financeiro" },
  { chave: "atendimento", rotulo: "Atendimento" },
  { chave: "gestao", rotulo: "Gestão" },
];

// Seções do painel — fonte única pra menu, rotas e permissões da equipe
const SECOES = [
  { chave: "dashboard", rotulo: "Dashboard", rota: "/", icone: "bi bi-speedometer2", grupo: "inicio" },
  { chave: "empresas", rotulo: "Empresas", rota: "/empresas", icone: "bi bi-buildings", grupo: "carteira" },
  { chave: "emprestimos", rotulo: "Empréstimos", rota: "/emprestimos", icone: "bi bi-cash-coin", grupo: "carteira" },
  { chave: "recebimentos", rotulo: "Recebimentos", rota: "/recebimentos", icone: "bi bi-wallet2", grupo: "carteira" },
  { chave: "visitas", rotulo: "Visitas", rota: "/visitas", icone: "bi bi-geo-alt", grupo: "carteira" },
  { chave: "caixa", rotulo: "Caixa", rota: "/caixa", icone: "bi bi-arrow-left-right", grupo: "financeiro" },
  { chave: "despesas", rotulo: "Despesas", rota: "/despesas", icone: "bi bi-receipt", grupo: "financeiro" },
  { chave: "contabilidade", rotulo: "Contabilidade", rota: "/contabilidade", icone: "bi bi-calculator", grupo: "financeiro" },
  { chave: "ia", rotulo: "Atendimento IA", rota: "/atendimento-ia", icone: "bi bi-robot", grupo: "atendimento", somenteDona: true },
  { chave: "prospeccao", rotulo: "Prospecção", rota: "/prospeccao", icone: "bi bi-megaphone", grupo: "atendimento", somenteDona: true },
  { chave: "teste", rotulo: "Ambiente de teste", rota: "/ambiente-teste", icone: "bi bi-robot", grupo: "atendimento", somenteDona: true },
  { chave: "documentos", rotulo: "Documentos", rota: "/documentos", icone: "bi bi-folder2-open", grupo: "gestao" },
  { chave: "relatorio", rotulo: "Relatório", rota: "/relatorio", icone: "bi bi-file-earmark-bar-graph", grupo: "gestao" },
];

// Admin ou permissoes null/vazia = acesso total (retrocompatível com usuários antigos e o robô)
function podeVer(usuario, chave) {
  if (!usuario) return false;
  // Seções exclusivas da Dona (Atendimento IA, Prospecção): só o painel da Dani,
  // nem a Bladon (que é admin isolada) nem a equipe dela veem.
  const secao = SECOES.find((s) => s.chave === chave);
  if (secao && secao.somenteDona && usuario.login !== "dani") return false;
  if (usuario.admin) return true;
  const permissoes = usuario.permissoes;
  if (!permissoes || permissoes.length === 0) return true;
  return permissoes.includes(chave);
}

function primeiraRotaPermitida(usuario) {
  const secao = SECOES.find((s) => podeVer(usuario, s.chave));
  return secao ? secao.rota : null;
}

export { SECOES, GRUPOS, podeVer, primeiraRotaPermitida };
